import React from "react";
import { useTranslation } from 'react-i18next';
import { InnerWeatherIcon } from "../../../../components/InnerWeatherIcon";
import { MindsetTrendChart } from "../../../../shared/components/MindsetTrendChart";

interface ScoreData {
  current: number;
  previous?: number;
  description?: string;
}

interface TrendPoint {
  composite_score: number;
  recorded_at: string;
}

interface Props {
  data: {
    neuroticism: ScoreData;
    well_being: ScoreData;
    self_efficacy: ScoreData;
    trend?: TrendPoint[];
  };
}

export const MindsetScoresWidget: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const a = data.neuroticism?.current ?? 50;
  const b = data.well_being?.current ?? 50;
  const c = data.self_efficacy?.current ?? 50;
  const trend = data.trend;

  return (
    <div className="bg-card rounded-xl border-2 border-border/50 p-3 mt-2 shadow-sm">
      <h4 className="font-semibold text-foreground mb-2 text-center text-sm">{t('widgets.innerWeather')}</h4>
      <div className="h-28 w-full mb-1">
        <InnerWeatherIcon a={a} b={b} c={c} className="h-full w-full" />
      </div>
      {trend && trend.length >= 2 && (
        <div className="text-center">
          <span className="text-xs text-muted-foreground mr-1">{t('widgets.trend')}</span>
          <MindsetTrendChart data={trend} />
        </div>
      )}
    </div>
  );
};
